$(".accordion_item-title").click(function () {
  $(this).toggleClass("is-open");
  $(this).next().toggleClass("is-open");
  $(this).next().slideToggle("slow");
});
